document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll("[data-accordion]");
  accordions.forEach(root => {
    const triggers = root.querySelectorAll(".pdp-acc__btn");
    triggers.forEach(btn => {
      btn.addEventListener("click", () => {
        const expanded = btn.getAttribute("aria-expanded") === "true";
        triggers.forEach(other => {
          if (other !== btn) {
            other.setAttribute("aria-expanded", "false");
            const panelId = other.getAttribute("aria-controls");
            const panel = root.querySelector("#" + panelId);
            if (panel) panel.hidden = true;
          }
        });
        btn.setAttribute("aria-expanded", String(!expanded));
        const panel = root.querySelector("#" + btn.getAttribute("aria-controls"));
        if (panel) panel.hidden = expanded;
      });
    });
  });
});